<input
  #codeInput
  class="sms-code__single"
  type="text"
  inputmode="numeric"
  autocomplete="one-time-code"
  pattern="[0-9]*"
  maxlength="4"
  aria-label="Enter verification code"
  (input)="onInput($event)" />
